import React, { Component } from 'react';
import cross from '../../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Upload from '../../shared/Upload';
import '../../../css/advertisement/AdvertisementData.css';
import SubmitModal from '../../shared/SuccessModal';
import AlertModal from '../../shared/AlertModal';
import message from '../../../data/Message.json';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ADDADVERTISEMENT_ENDPOINT, ADVERTISEMENTSLOT_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let isSlotAvailable = false;
class AdvertisementData extends Component {
  constructor(props) {
    super(props)
    this.container = React.createRef();
    this.state = {
      publishHasOpen: false,
      advertisementName: '',
      url: '',
      effectiveDateCalendar: new Date(),
      expiryDateCalendar: new Date(),
      showEffectiveCalendar: false,
      showExpiryCalendar: false,
      imageUploadLink: '',
      isUploadDisabled: false,
      isDeleteDisabled: true,
      errors: {},
      renderEffectiveCalendar: false,
      renderExpiryCalendar: false,
      hasOpenAlert: false,
      advertisementSlot: [],
    }
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleClickOutside);
    ApiCall(
      'GET',
      utilityBaseURL + ADVERTISEMENTSLOT_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ' x-cc-trace-id': '1234',
      },
    ).then((apiData) => {
      if (apiData.flag !== -1) {
        if (apiData.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          console.log(apiData);
          this.setState({ advertisementSlot: apiData });
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
  }
  monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }
  setImageUploadLink = (imagePathURL) => {
    this.setState({ imageUploadLink: imagePathURL })
  }
  removeImageUploadedLink = () => {
    this.setState({ imageUploadLink: '' })
  }
  validateFormFields = () => {
    return this.state.advertisementName.length > 0 &&
      this.state.renderEffectiveCalendar && this.state.renderExpiryCalendar &&
      this.state.url.length > 0 &&
      this.state.imageUploadLink.length > 0
  };
  handleSubmit = () => {
    if (this.handleValidation()) {
      this.onhandlePublish();
    }
  }
  getTileStatus = (tileDate, tileMonth) => {
    let checkSlot = false;
    this.state.advertisementSlot.map(
      slotAvailable => {
        let x = slotAvailable.adDate
        let dateParts = x.split("/");
        let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
        if (tileDate === date.getDate() && tileMonth === date.getMonth() && slotAvailable.slotAvailable === 0) {
          checkSlot = true
        }
        return true;
      })
    return checkSlot
  }
  getAvailablity = () => {
    let fromDate = new Date(this.state.effectiveDateCalendar).getTime();
    let toDate = new Date(this.state.expiryDateCalendar).getTime()
    let time_difference = toDate - fromDate;
    let days_difference = time_difference / (1000 * 60 * 60 * 24);
    let count = 0;
    let dateArray = []
    this.state.advertisementSlot.map(
      slotAvailable => {
        let x = slotAvailable.adDate
        let dateParts = x.split("/");
        let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
        dateArray.push({
          dateTime: date.getTime(),
          date: date.getDate(),
          month: date.getMonth(),
          year: date.getFullYear(),
          slotAvailable: slotAvailable.slotAvailable
        })
        return true;
      })
    // WHILE LOOP
    var loop = new Date(fromDate);
    while (loop <= new Date(toDate) || dateArray.map(slot => slot.slotAvailable) > 0) {
      if (this.getTileStatus(loop.getDate(), loop.getMonth())) {
        break;
      }
      count = count + 1;
      var newDate = loop.setDate(loop.getDate() + 1);
      loop = new Date(newDate);
    }
    var checkSlots = days_difference + 1;
    checkSlots = Math.round(checkSlots);
    if (checkSlots === count) {
      isSlotAvailable = true;
    }
    else {
      isSlotAvailable = false;
    }
    return isSlotAvailable;
  }
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let patternCharacter = new RegExp(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/);
    if (!patternCharacter.test(this.state.url)) {
      formIsValid = false;
      errors["url"] = message.validation.validUrl;
    }
    else if (this.state.effectiveDateCalendar.getFullYear() > this.state.expiryDateCalendar.getFullYear()) {
      formIsValid = false;
      errors["todate"] = message.validation.date;
    }
    else if (this.state.effectiveDateCalendar.getFullYear() === this.state.expiryDateCalendar.getFullYear()) {
      if (this.state.effectiveDateCalendar.getMonth() === this.state.expiryDateCalendar.getMonth()) {
        if (this.state.effectiveDateCalendar.getDate() > this.state.expiryDateCalendar.getDate()) {
          formIsValid = false;
          errors["todate"] = message.validation.date;
        }
      }
      else if (this.state.effectiveDateCalendar.getMonth() > this.state.expiryDateCalendar.getMonth()) {
        formIsValid = false;
        errors["todate"] = message.validation.date;
      }
    }
    this.setState({ errors: errors });
    return formIsValid;
  }
  onPublish = () => {
    this.setState({ publishHasOpen: false })
    this.props.onClosePublish()
  }
  onCloseAlert = () => {
    this.setState({ hasOpenAlert: false })
  }
  onhandlePublish = () => {
    let fromTimeStamp = this.state.effectiveDateCalendar;
    let toTimeStamp = this.state.expiryDateCalendar;
    fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(fromTimeStamp).toString().substring(0, 10));
    toTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(toTimeStamp).toString().substring(0, 10));
    if (!this.getAvailablity()) {
      this.setState({ hasOpenAlert: true })
    }
    else {
      ApiCall(
        'POST',
        utilityBaseURL + ADDADVERTISEMENT_ENDPOINT,
        {
          "aDCompany": this.state.advertisementName,
          "aDImageMobileLink": this.state.imageUploadLink,
          "aDImageWebLink": this.state.imageUploadLink,
          "aDLink": this.state.url,
          "fromDate": fromTimeStamp,
          "toDate": toTimeStamp,
        },
        {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-cc-trace-id': '1234',
        }
      ).then(data => {
        if (data.flag !== -1) {
          if (data.flag === 500) {
            // this.setState({ hasOpenAlert: true })
            if (data.data.errors.TPT0004) {
              let errors = {};
              errors["todate"] = message.validation.date;
              this.setState({ errors: errors });
            }
            else {
              toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
          }
          else {
            console.log('I am 200!');
            this.setState({ publishHasOpen: true })
          }
        }
        else {
          // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
        }
      })
    }
  }
  handleUrl = (e) => {
    this.setState({
      url: e.target.value,
      errors: {
        ...this.state.errors,
        url: ''
      }
    })
    console.log("year", this.state.effectiveDateCalendar.getFullYear(), "month",
      this.state.effectiveDateCalendar.getMonth(), "date", this.state.effectiveDateCalendar.getDate())
    console.log("xx", this.state.effectiveDateCalendar)
  }
  //formDate
  handleEffectiveDateChanged = (e) => {
    this.setState({
      effectiveDateCalendar: e, showEffectiveCalendar: false,
      errors: {
        ...this.state.errors,
        todate: ''
      }
    });
  }
  toggleEffectiveCalendar = () => {
    this.setState({ showEffectiveCalendar: !this.showEffectiveCalendar, renderEffectiveCalendar: true });
  }
  //toDate
  handleExpiryDateChanged = (e) => {
    this.setState({
      expiryDateCalendar: e, showExpiryCalendar: false,
      errors: {
        ...this.state.errors,
        todate: ''
      }
    });
  }
  toggleExpiryCalendar = () => {
    this.setState({ showExpiryCalendar: !this.showExpiryCalendar, renderExpiryCalendar: true });
  }
  handleClickOutside = event => {
    if (this.container.current && !this.container.current.contains(event.target)) {
      this.setState({ showEffectiveCalendar: false });
      this.setState({ showExpiryCalendar: false });
    }
  };
  render() {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let effectiveDateValue = this.state.effectiveDateCalendar.getDate() + "-" + months[this.state.effectiveDateCalendar.getMonth()] + "-" + this.state.effectiveDateCalendar.getFullYear();
    if (this.state.effectiveDateCalendar.getDate() <= 9) {
      effectiveDateValue = "0" + effectiveDateValue;
    }
    let expiryDateValue = this.state.expiryDateCalendar.getDate() + "-" + months[this.state.expiryDateCalendar.getMonth()] + "-" + this.state.expiryDateCalendar.getFullYear();
    if (this.state.expiryDateCalendar.getDate() <= 9) {
      expiryDateValue = "0" + expiryDateValue;
    }
    return (
      <div class="advertisementModalOuter" >
        <MetaDecorator title={TitleDescription.advertisementDataPageTitle} description={TitleDescription.advertisementDataPageDescription} />
        <div class="advertisementModalInner" >
          <div className='advertisementcross'>
            <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
          </div>
          <div class="advertisementupperdiv">
            <small class="advertisementTitle">
              Advertisement
          </small>
          </div>
          <div>
            <div class="advertisementlowerdiv" >
              <div class="advertisementlowerin">
                <div class="advertisementContainer">
                  <div class="advertisementLeftPart">
                    <div className="imageTextContainer">
                      <p className="imageText">Image*</p>
                    </div>
                    <div className="">
                      <div>
                        <Upload idupload="imageUpload" output="imageOutput"
                          isUploadDisabled={this.state.isUploadDisabled}
                          isDeleteDisabled={this.state.isDeleteDisabled}
                          setImageLink={this.setImageUploadLink}
                          handleRemove={this.removeImageUploadedLink}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="advertisementRightPart">
                    <div class="advertisementCompanyContainer">
                      <small class="adLabel">Advertising Company</small>
                      <input class="copyInput" type="text" placeholder="Enter company name" value={this.state.advertisementName} onChange={(e) => this.setState({ advertisementName: e.target.value })}></input>
                    </div>
                    <div className="fromtoContainer">
                      <div>
                        <small class="adLabel">Effective Date</small>
                        <div className="fromtoTextinput">
                          <div class="advertisementDateInput">
                            <input class="advertisementinputlbor" placeholder="Select Date" value={this.state.renderEffectiveCalendar ? effectiveDateValue : null}></input>
                          </div>
                          <div class="advercalender">  {this.state.showEffectiveCalendar ? <div ref={this.container}>
                            <Calendar onChange={this.handleEffectiveDateChanged} value={this.effectiveDateCalendar} minDate={new Date()}
                              tileDisabled={({ activeStartDate, date, view }) => this.getTileStatus(date.getDate(), date.getMonth())}
                            />
                          </div> : null}</div>
                          <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" onClick={this.toggleEffectiveCalendar}
                          />
                        </div>
                      </div>
                      <div>
                        <small class="adLabel">Expiry Date</small>
                        <div className="fromtoTextinput">
                          <div class="advertisementDateInput">
                            <input class="advertisementinputlbor" placeholder="Select Date" value={this.state.renderExpiryCalendar ? expiryDateValue : null}></input>
                          </div>
                          <div class="advercalender">  {this.state.showExpiryCalendar ? <div ref={this.container}>
                            <Calendar onChange={this.handleExpiryDateChanged} value={this.expiryDateCalendar} minDate={this.state.effectiveDateCalendar}
                              tileDisabled={({ activeStartDate, date, view }) => this.getTileStatus(date.getDate(), date.getMonth())}
                            />
                          </div> : null}</div>
                          <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1" alt="" loading="lazy" onClick={this.toggleExpiryCalendar}
                          />
                        </div>
                      </div>
                      <div className="errordate">{this.state.errors["todate"]}</div>
                    </div>
                    <div class="advertisementUrlContainer">
                      <small class="adLabel">URL</small>
                      <input class="urlInput" placeholder="Enter your URL" value={this.state.url} onChange={this.handleUrl}></input>
                      <div className="errorInvalidUrl">{this.state.errors["url"]}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="advertisementbefore">
                <div>
                  <p className="req">*Requirements:</p>
                  <pre className="reqText">
                    Type: <span className="reqValue">jpeg, jpg, png;</span><br />
                   File Size: <span className="reqValue">2 MB (Maximum);</span><br />
                   Dimensions: <span className="reqValue">1440 x 500 pixels (Minimum)</span>
                  </pre>
                </div>
                <div class="advertisementafter">
                  <button class="advertisementPublishButton" disabled={!this.validateFormFields()} onClick={this.handleSubmit}><small class="advertisementSubmitText">Publish</small></button>
                </div>
              </div>
            </div>
            <SubmitModal onClick={this.onPublish} hasOpen={this.state.publishHasOpen} >
              <div className="sectionTextContainer">
                <p className="sectionText">Your advertisement has been published successfully</p>
              </div>
            </SubmitModal>
            <AlertModal onClick={this.onCloseAlert} hasOpen={this.state.hasOpenAlert} >
              <div className="alertSectionTextContainer">
                <p className="alertSectionText">You have selected invalid date range as slot is not available for some of the dates for this date range. Please select different date range.</p>
              </div>
            </AlertModal>
          </div>
        </div>
      </div>
    );
  }
}
export default AdvertisementData;